var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M54.526,46.126c-1.445,0-2.62,1.175-2.62,2.619c0,1.445,1.175,2.62,2.62,2.62c1.445,0,2.62-1.175,2.62-2.62 C57.146,47.301,55.971,46.126,54.526,46.126z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.952,66.525H62.51V27.475c0-1.104-0.896-2-2-2H35.49c-1.104,0-2,0.896-2,2v39.051h-7.442c-1.104,0-2,0.896-2,2 s0.896,2,2,2h9.442h25.02h9.442c1.104,0,2-0.896,2-2S71.057,66.525,69.952,66.525z M37.49,66.525V29.475h21.02v37.051H37.49z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoor);
export default __webpack_public_path__ + "static/media/door.e72f1b0241e4261429c29486e4f1a145.svg";
export { ForwardRef as ReactComponent };